import React, { useEffect, useState } from 'react';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';

const EnrollmentSuccess = () => {
  const navigate = useNavigate();
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    // Create confetti animation
    const createConfetti = () => {
      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3'];
      const newConfetti = [];
      
      for (let i = 0; i < 100; i++) {
        newConfetti.push({
          id: i,
          x: Math.random() * window.innerWidth,
          y: -10,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: Math.random() * 10 + 5,
          speed: Math.random() * 3 + 2,
          rotation: Math.random() * 360,
          rotationSpeed: Math.random() * 10 - 5
        });
      }
      
      setConfetti(newConfetti);
    };

    createConfetti();

    // Animate confetti
    const interval = setInterval(() => {
      setConfetti(prev => 
        prev.map(piece => ({
          ...piece,
          y: piece.y + piece.speed,
          rotation: piece.rotation + piece.rotationSpeed
        })).filter(piece => piece.y < window.innerHeight + 50)
      );
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="page-container" style={{ 
      maxWidth: 800, 
      margin: '0 auto', 
      background: '#fff', 
      padding: 32, 
      borderRadius: 8,
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh'
    }}>
      {/* Confetti Animation */}
      {confetti.map(piece => (
        <div
          key={piece.id}
          style={{
            position: 'fixed',
            left: piece.x,
            top: piece.y,
            width: piece.size,
            height: piece.size,
            backgroundColor: piece.color,
            borderRadius: '50%',
            transform: `rotate(${piece.rotation}deg)`,
            zIndex: 1000,
            pointerEvents: 'none'
          }}
        />
      ))}

      <div style={{ textAlign: 'center', position: 'relative', zIndex: 1001 }}>
        {/* Success Icon */}
        <div style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          backgroundColor: '#28a745',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 32px',
          boxShadow: '0 8px 32px rgba(40, 167, 69, 0.3)'
        }}>
          <span style={{ fontSize: 60, color: '#fff' }}>✓</span>
        </div>

        <h1 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          color: '#2c3e50',
          marginBottom: '16px'
        }}>
          Welcome to Dual School! 🎉
        </h1>

        <div style={{ 
          fontSize: '1.25rem', 
          color: '#6c757d',
          marginBottom: '32px',
          lineHeight: '1.6'
        }}>
          <p>We are so excited to have you as part of this incredible journey!</p>
          <p>Your enrollment contract has been successfully signed and submitted.</p>
        </div>

        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '24px',
          borderRadius: '12px',
          marginBottom: '32px',
          border: '2px solid #e9ecef'
        }}>
          <h2 style={{ 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
            color: '#495057',
            marginBottom: '16px'
          }}>
            What's Next?
          </h2>
          <ul style={{ 
            textAlign: 'left', 
            fontSize: '1.1rem', 
            lineHeight: '1.8',
            color: '#495057'
          }}>
            <li>💵 View your payment options and make your first tuition payment</li>
            <li>📚 Our team will begin preparing your student's personalized academic pathway</li>
            <li>📅 Schedule your initial consultation and personalized orientation</li>
            <li>💻 You'll get access to your student portal and resources</li>
            <li>🎓 You and your student will receive a welcome email with next steps</li>
          </ul>
        </div>

        <div style={{
          backgroundColor: '#e3f2fd',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '32px',
          border: '1px solid #bbdefb'
        }}>
          <p style={{ 
            fontSize: '1.1rem', 
            color: '#1976d2',
            margin: 0,
            fontWeight: '500'
          }}>
            💡 <strong>Pro Tip:</strong> Check your email regularly for important updates and next steps!
          </p>
        </div>
        <div style={{ 
          marginTop: '32px', 
          padding: '20px',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          border: '1px solid #ffeaa7'
        }}>
          <p style={{ 
            fontSize: '1rem', 
            color: '#856404',
            margin: 0,
            fontStyle: 'italic'
          }}>
            🎊 Congratulations on taking this exciting step toward your student's future! 
            You're now part of the Dual School family.
          </p>
        </div>
        <div style={{marginTop: '32px',  display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          
          <Button
            onClick={() => navigate('/parent-applications')}
            style={{
              padding: '12px 24px',
              backgroundColor: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            Go to Dashboard
          </Button>
        </div>

        
      </div>
    </div>
  );
};

export default EnrollmentSuccess; 